import React, { useEffect } from 'react';

const AppleSignIn = ({ config, render, onSuccess, onFailure }) => {

    const APPLEID_AUTH_SDK_URL =
        "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";
    const APPLEID_AUTH_SDK_ELEMENT_ID = "__appleid_auth_sdk";

    // 1. Load Apple SDK
    const loadSDK = () =>
        new Promise((resolve, reject) => {
            const existingScript = document.getElementById(APPLEID_AUTH_SDK_ELEMENT_ID);
            if (existingScript) return resolve();

            const script = document.createElement("script");
            script.src = APPLEID_AUTH_SDK_URL;
            script.id = APPLEID_AUTH_SDK_ELEMENT_ID;
            script.async = true;
            script.onload = resolve;
            script.onerror = reject;
            document.body.appendChild(script);
        });

    // 2. Wait for window.AppleID.auth to actually exist
    const waitForApple = () =>
        new Promise((resolve) => {
            const check = () => {
                if (window.AppleID?.auth) return resolve();
                setTimeout(check, 30);
            };
            check();
        });

    useEffect(() => {
        let cancelled = false;

        const initialize = async () => {
            try {
                await loadSDK();
                await waitForApple();       // <-- the missing piece
                if (!cancelled) {
                    window.AppleID.auth.init(config);
                }
            } catch (err) {
                console.error("Failed to load AppleID SDK", err);
            }
        };

        initialize();

        return () => { cancelled = true; };
    }, [config]);

    // 3. Handle click → Apple Sign In
    const onClick = async (e) => {
        if (e) e.preventDefault();

        try {
            const data = await window.AppleID.auth.signIn();
            onSuccess(data);
        } catch (error) {
            onFailure(error);
        }
    };

    // 4. Custom button renderer
    if (typeof render === "function") {
        return render({ onClick });
    }

    return (
        <div id="appleid-signin" onClick={onClick}>
            <img
                src="https://developer.apple.com/design/human-interface-guidelines/sign-in-with-apple/images/apple-id-continue-with_2x.png"
                alt="Sign in with Apple"
            />
        </div>
    );
};

export default AppleSignIn;